module.exports = __webpack_public_path__ + "img/successed.37cd9f98.png";